import {BankTransactionResponse} from "@/types/service-response";
import Transaction from "@/model/BankTransaction/Transaction";
import TransactionBoarder from "@/model/BankTransaction/TransactionBoarder";
import TransactionInvoice from "@/model/BankTransaction/TransactionInvoice";

export default class BankTransaction {
  private constructor(
      readonly amountToWallet: number,
      readonly transaction: Transaction,
      readonly boarder: TransactionBoarder | null,
      readonly invoices: TransactionInvoice[]
  ) {}


  static createFromResponse(responseData: BankTransactionResponse): BankTransaction {

    return new BankTransaction(
        responseData.amountToWallet,
        Transaction.createFromResponse(responseData.transaction),
        responseData.boarder ? TransactionBoarder.createFromResponse(responseData.boarder) : null,
        TransactionInvoice.createFromResponse(responseData.invoices)
    )
  }

  static createFromResponseList(responseData: BankTransactionResponse[]): BankTransaction[] {
    return responseData.map((item:BankTransactionResponse) => {
      return new BankTransaction(
          item.amountToWallet,
          Transaction.createFromResponse(item.transaction),
          item.boarder ? TransactionBoarder.createFromResponse(item.boarder) : null,
          TransactionInvoice.createFromResponse(item.invoices)
      )
    })
  }
}